export default __webpack_public_path__ + "static/media/NodeJS.dd47e26e.svg";